import {useParams} from 'react-router-dom';
import '../settings.professional-caregiver.screen.scss';
import {Box, Card, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../i18n/translations';
import {AffiliatedEntityProfile} from '../../../../../../components/affiliated-entity-profile/affiliated-entity-profile';
import GenericHeader from '../../../../../../components/generic-header/generic-header';
import {useAuth} from '../../../../../../contexts/auth/context';
import {useOffice} from '../../../../../../contexts/office/context';
import {ScreenPaths} from '../../../../../../enums';
import {RolePermissionType} from '../../../../../../backend/enums/role-permission-type';

export default function InstitutionProfileProfessionalCaregiverScreen() {
  const {t} = useTranslation();

  const {state: authState, hasWritePermission} = useAuth();
  const canWrite = hasWritePermission(RolePermissionType.Settings_Entity_Profile);

  const officeContext = useOffice();

  let {entityId}: {entityId: string} = useParams();

  return (
    <Box className="settings-menu-wrapper">
      <GenericHeader
        titleCrumbs={[
          {
            label: t(
              translations.office.professional_caregiver.settings.generic_header.breadcrumbs
                .settings
            ),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${authState.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Settings}`,
          },
          {
            label: t(
              translations.office.professional_caregiver.settings.generic_header.breadcrumbs
                .institution
            ),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${authState.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Settings}${ScreenPaths.ProfessionalCaregiver_InstitutionSettings}`,
          },
        ]}
        isLoading={officeContext.state.entityFormLoadingState}
        leftColumn={
          <Typography className="settings-menu-header-title" noWrap>
            {canWrite
              ? t(
                  translations.office.professional_caregiver.settings.generic_header.subtitle
                    .institution.write
                )
              : t(
                  translations.office.professional_caregiver.settings.generic_header.subtitle
                    .institution.read
                )}
          </Typography>
        }
      />
      <Box>
        <Card className="settings-menu-card" elevation={0}>
          <AffiliatedEntityProfile
            canWrite={canWrite}
            entityId={entityId}
            redirectUrl={`${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${authState.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Activity}`}
          />
        </Card>
      </Box>
    </Box>
  );
}
